import printCheckinComponent from './print_checkin.component';

let printCheckinModule = angular.module('printCheckin', [
	])
	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";

		$urlRouterProvider.otherwise('/checkin');

		$stateProvider
			.state('printCheckin', {
				url: '/print-checkin/{branchId}/{scannedRouteId}/{date}',
				component: 'printCheckin',
				data: {
					requireLogin: true,
					requireACL: 'check_in.all'	
				},
			});
	})

	.component('printCheckin', printCheckinComponent)

	.name;

export default printCheckinModule;

// ?branch&route&date



// WEBPACK FOOTER //
// ./client/app/components/checkin/print/index.js